import { render } from "./PromoListDetail.vue?vue&type=template&id=643ba42b&scoped=true"
import script from "./PromoListDetail.vue?vue&type=script&lang=js"
export * from "./PromoListDetail.vue?vue&type=script&lang=js"

import "./PromoListDetail.vue?vue&type=style&index=0&id=643ba42b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643ba42b"]])

export default __exports__